import React, { useState, useEffect } from 'react';
import { translate } from 'react-switch-lang';
import { ListingDatatable } from '../../_fragments';
import Form from './Form';
import { assetAccountSchema as schema } from '../../_validationSchema';
import { assetAccountAction as actions } from '../../_action/assetAccount.action';
import { assetAccount_model as model } from '../../_model';
import { assetAccountConstants as constants } from '../../_constants';
import { assetAccountTypeConstants as type_constants } from '../../_constants';
import { useSelector } from 'react-redux';

const AssetAccount = (props) => {
  const { t } = props;

  const header = { name: 'Account', icon: 'cubes' };
  const reducer = useSelector((state) => state.assetAccountOperation);
  const [item, setItem] = React.useState({});

  const filenameXML = 'AccountGFT';
  const menuCode = 'M_ASSET_ACCOUNT';

  const columns = [
    { title: t('Code'), field: 'Code' },
    { title: t('Description'), field: 'Description' },
    { title: t('Account Type'), field: 'LocationTypeGFTDescription' },
  ];

  let useService = () => {
    return [schema, actions, model, constants, type_constants];
  };

  const [open, setOpen] = useState(false);
  const [selectedCode, setSelected] = useState('');
  const [type, setFormType] = useState('');
  const [keyTrigger, setTrigger] = useState(false);

  useEffect(() => {
    if (open === false) {
      setFormType('');
      setTrigger(!keyTrigger);
    }
  }, [open]);

  useEffect(() => {
    if (reducer.getSuccess) {
      setItem(reducer.data.data.info);
    }
  }, [reducer]);

  return (
    <>
      <Form
        type={type}
        header={header}
        code={selectedCode}
        open={open}
        setClose={() => setOpen(false)}
        useService={useService}
        reducer={reducer}
        item={item}
      />
      <ListingDatatable
        key={keyTrigger}
        header={header}
        columns={columns}
        filenameXML={filenameXML}
        setSelected={setSelected}
        setFormOpen={setOpen}
        setFormType={setFormType}
        menuCode={menuCode}
      />
    </>
  );
};

export default translate(AssetAccount);
